import { GridColDef } from '@mui/x-data-grid';
import { ActiveListItem } from '../listItems/ActiveListItem';
import { ITranslator } from 'translation/generated/translationInterface';

export const activeColumnDefinition = (translator: ITranslator): GridColDef => {
  return {
    field: 'active',
    headerName: translator.active(),
    type: 'boolean',
    width: 100,
    renderCell: (params) => {
      const active = params.row.active;
      return <ActiveListItem active={active} activeTooltip="" inactiveTooltip="" />;
    }
  };
};
